module.exports = __webpack_public_path__ + "img/Lisensi-KreditPro.00774726.webp";